export class TableNumberBar {
  constructor(tableNumber = null) {
    this.tableNumber = tableNumber || this.getMockTableNumber();
  }

  getMockTableNumber() {
    return '12';
  }

  setTableNumber(tableNumber) {
    this.tableNumber = tableNumber;
    this.updateDisplay();
  }

  render() {
    return `
      <div class="table-number-bar" id="table-number-bar">
        <div class="table-number-content">
          <span class="table-label">Stolik</span>
          <span class="table-number" id="table-number-display">${this.tableNumber}</span>
        </div>
      </div>
    `;
  }

  updateDisplay() {
    const displayElement = document.getElementById('table-number-display');
    if (displayElement) {
      displayElement.textContent = this.tableNumber;
    }
  }

  show() {
    const element = document.getElementById('table-number-bar');
    if (element) {
      element.style.display = 'flex';
    }
  }

  hide() {
    const element = document.getElementById('table-number-bar');
    if (element) {
      element.style.display = 'none';
    }
  }
}